import {
  Paper,
  useMediaQuery,
  useTheme,
  Container,
  Grid2,
  Box,
} from "@mui/material";
import { motion } from "framer-motion";
import Lamp from "../../ui/AnimatedLamp";
import { AnimatedButton } from "../../ui/AnimatedButton";
import StyledTypography from "../../ui/StyledTypography";
import { Link } from "react-router-dom";

export default function GetInTouch() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Lamp>
      <motion.div
        initial={{ opacity: 0.5, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{
          delay: 0.3,
          duration: 0.8,
          ease: "easeInOut",
        }}
      >
        <StyledTypography
          variant="h1"
          sx={{
            textAlign: "center",
            fontSize: { xs: "2.5rem", md: "4rem" },
            fontWeight: 500,
            transform: "translateY(-4rem)",
          }}
          colors={[theme.palette.grey[300], theme.palette.grey[500]]}
        >
          Get In Touch
        </StyledTypography>
        <Container maxWidth="md" sx={{ transform: "translateY(-2rem)" }}>
          <Paper sx={{ py: 5, px: 3 }}>
            <StyledTypography
              variant={isMobile ? "h5" : "h4"}
              colors={[theme.palette.grey[300], theme.palette.grey[500]]}
              sx={{ fontWeight: 500 }}
              component={"div"}
            >
              How I can help{" "}
              <StyledTypography
                variant={isMobile ? "h5" : "h4"}
                colors={[theme.palette.grey[300], theme.palette.grey[500]]}
                sx={{
                  fontFamily: "'Modure Placeholder', serif",
                  fontStyle: "italic",
                  display: "inline",
                  fontWeight: 500,
                }}
                component={"span"}
              >
                you?
              </StyledTypography>
            </StyledTypography>

            <StyledTypography
              variant="body1"
              colors={[theme.palette.grey[500], theme.palette.grey[900]]}
              sx={{ mt: 2, fontSize: "1rem", fontWeight: 400 }}
            >
              Whether you’re a startup, a small business, or an established
              company, I’m here to help. Contact me today to discuss your
              project and start crafting your perfect online solution!
            </StyledTypography>
            <Grid2 container spacing={4} mt={2}>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <StyledTypography
                  variant="body1"
                  colors={[theme.palette.grey[500], theme.palette.grey[900]]}
                >
                  Want me to build you a completely custom, beautiful &
                  highly-converting landing page?
                </StyledTypography>
              </Grid2>

              <Grid2 size={{ xs: 12, md: 6 }}>
                <StyledTypography
                  variant="body1"
                  colors={[theme.palette.grey[500], theme.palette.grey[900]]}
                >
                  Want me to build you a completely custom, beautiful &
                  highly-converting landing page?
                </StyledTypography>
              </Grid2>
            </Grid2>
            <Box
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-start" },
                mt: 4,
              }}
            >
              <Link to="/contact">
                <AnimatedButton
                  backgroundColor={"#353845"}
                  textColor="rgba(255, 255, 255, .5)"
                  gradientColor={theme.palette.primary.main}
                  glowStart={theme.palette.primary.light}
                  glowEnd={theme.palette.primary.dark}
                  borderRadius="0.75rem"
                  sx={{
                    width: "14rem",
                    fontSize: "1.2rem",
                    fontWeight: 600,
                    textShadow: "none",
                  }}
                >
                  Contact Me
                </AnimatedButton>
              </Link>
            </Box>
          </Paper>
        </Container>
      </motion.div>
    </Lamp>
  );
}
